import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../service/auth.service';
import { TranslocoService } from '@jsverse/transloco';
import { SidenavInterface } from '@stdoutsrl/design-kit';

@Component({
  selector: 'app-container-public',
  template: `
    <div *transloco="let t">
      <div class="dark h-screen w-screen bg-[#F28F17]">
        <div
          class="max-h-[calc(100dvh)] overflow-x-hidden overflow-y-scroll custom-scroll"
        >
          <div class="min-h-[calc(100dvh-250px)]">
            <router-outlet></router-outlet>
          </div>
          <app-footer></app-footer>
        </div>
      </div>
    </div>
  `,
  styles: [],
  standalone: false,
})
export class ContainerPublicComponent implements OnInit {
  constructor(
    private router: Router,
    private auth: AuthService,
    private translocoService: TranslocoService,
  ) {}
  window = window;
  logged = false;
  currentBreadcrumb: any = null;
  userInfo = { username: 'Gino Rapollo' };
  menuItems: SidenavInterface[] = [];
  isMenuOpen = window.innerWidth > 768;
  userData: any = {};

  ngOnInit(): void {
    if (localStorage.getItem('token')) {
      this.getMe();
    } else {
      // localStorage.clear();
      // window.location.replace("login");
    }
  }

  changeMenu() {
    this.isMenuOpen = !this.isMenuOpen;
  }

  menuChanged(menuExpanded: boolean) {
    this.isMenuOpen = menuExpanded;
  }

  getMe() {
    this.translocoService.selectTranslateObject('routes').subscribe((route) => {
      this.menuItems = [];
      if (this.router.config[0].children) {
        this.router.config[0].children.forEach((path: any) => {
          if (path?.data?.showSideNav && path?.data?.route) {
            this.menuItems.push({
              text: path.title,
              route: '/' + path.path,
              iconUrl: '../assets/employee.svg',
            });
          }
        });
      }
      this.logged = true;
    });
  }

  goTo(menuItem: any) {
    this.router.navigate([menuItem.route]);
    if (window.innerWidth <= 768) {
      this.isMenuOpen = false;
    }
  }
  userClick() {
    this.translocoService.selectTranslateObject('routes').subscribe((route) => {
      this.router.navigate([route.userProfile.path]);
      this.logged = true;
    });
    if (window.innerWidth <= 768) {
      this.isMenuOpen = false;
    }
  }
}
